import { useMemo } from "react";

import { useListDatabasesQuery } from "metabase/api";
import { getUser } from "metabase/current-user";
import { getDashboard } from "metabase/dashboard/shell-selectors";
import { AdminNavbar } from "metabase/nav/components/AdminNavbar";
import { MainNavbar } from "metabase/nav/containers/MainNavbar";
import {
  PbiRail,
  useNavigationExperience,
} from "metabase/nav/containers/PbiRail";
import { connect } from "metabase/redux";
import type { AdminPath, State, StoreDashboard } from "metabase/redux/store";
import { useLocation, useParams } from "metabase/router";
import { getAdminPaths } from "metabase/selectors/admin";
import { getIsNavbarOpen } from "metabase/selectors/app";
import type { User } from "metabase-types/api";

type NavbarProps = {
  isOpen: boolean;
  user: User | null;
  adminPaths: AdminPath[];
  dashboard?: StoreDashboard;
};

const mapStateToProps = (state: State) => ({
  isOpen: getIsNavbarOpen(state),
  user: getUser(state),
  adminPaths: getAdminPaths(state),
  // Can't use the dashboard entity loader instead.
  // The dashboard page uses DashboardsApi.get directly,
  // so we can't re-use data between these components.
  dashboard: getDashboard(state),
});

function NavbarInner({ isOpen, user, adminPaths, dashboard }: NavbarProps) {
  const location = useLocation();
  const params = useParams();
  useListDatabasesQuery();
  const isAdminApp = useMemo(
    () => location.pathname.startsWith("/admin/"),
    [location.pathname],
  );
  const navigationExperience = useNavigationExperience();

  if (!user) {
    return null;
  }

  return isAdminApp ? (
    <AdminNavbar path={location.pathname} adminPaths={adminPaths} />
  ) : navigationExperience === "pbi" ? (
    <PbiRail isOpen={isOpen} />
  ) : (
    <MainNavbar
      isOpen={isOpen}
      location={location}
      params={params}
      dashboard={dashboard}
    />
  );
}

export const Navbar = connect(mapStateToProps)(NavbarInner);
